import Image from "next/image";

type ContainedImageProps = {
  src: string;
  alt: string;
  className?: string;
  imageClassName?: string;
  fit?: "cover" | "contain";
  priority?: boolean;
  /** Opt out of lazy loading, for frames that scroll themselves into view. */
  eager?: boolean;
  sizes?: string;
};

export default function ContainedImage({
  src,
  alt,
  className = "",
  imageClassName = "",
  fit = "cover",
  priority = false,
  eager = false,
  sizes = "(max-width: 768px) 100vw, 50vw",
}: ContainedImageProps) {
  return (
    <div className={`relative overflow-hidden ${className}`}>
      <Image
        src={src}
        alt={alt}
        fill
        priority={priority}
        loading={!priority && eager ? "eager" : undefined}
        sizes={sizes}
        className={`${fit === "contain" ? "object-contain" : "object-cover"} ${imageClassName}`}
      />
    </div>
  );
}
